import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { RegisterPageViewProps } from './registerpage.props';

const RegisterPageView: React.FC<RegisterPageViewProps> = ({
  formData,
  isLoading,
  handleChange,
  handleSubmit,
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">Регистрирајте се</CardTitle>
          <CardDescription className="text-center">
            Креирајте нов профил за да продолжите
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="name">Име</Label>
              <Input id="name" name="name" value={formData.name} onChange={handleChange} required className="mt-1" placeholder="Вашето име" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required className="mt-1" placeholder="vase@email.com" />
            </div>
            <div>
              <Label htmlFor="password">Лозинка</Label>
              <Input id="password" name="password" type="password" value={formData.password} onChange={handleChange} required className="mt-1" placeholder="••••••••" />
            </div>
            <div>
              <Label htmlFor="confirmPassword">Потврди лозинка</Label>
              <Input id="confirmPassword" name="confirmPassword" type="password" value={formData.confirmPassword} onChange={handleChange} required className="mt-1" placeholder="••••••••" />
            </div>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" disabled={isLoading}>
              {isLoading ? 'Се регистрирам...' : 'Регистрирај се'}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm">
            <span className="text-gray-600">Веќе имате профил? </span>
            <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">
              Најавете се
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RegisterPageView;
